<template>
    <span>
        <dashboardescola></dashboardescola>
    </span>
</template>

<script>
import Dashboardescola from '@/components/Dashboard-Escola';

export default {
    name: 'caddashboardescola',
    components: {
        Dashboardescola
    }
};
</script>